// This is the height of the header bar fixed at the top of the page
// We use it so that when we scroll to the top of a list with pagination,
// the top of the list isn't hidden behind the header.
export const fixedHeaderHeight = 88;
